export const globalEventslog = {};
